<script setup lang="ts">
import { useTemplateRef } from 'vue';
import FormTextInput from './FormTextInput.vue';

defineProps<{
  name: string;
  placeholder?: string;
}>();

const inputRef = useTemplateRef('inputRef');

defineExpose({
  focus: () => inputRef.value?.focus(),
  resetField: () => inputRef.value?.resetField(),
  setValue: (val: string, shouldValidate = false) => inputRef.value?.setValue(val, shouldValidate),
  getValue: () => inputRef.value?.getValue(),
});
</script>

<template>
  <!-- For values the user must type, such as type-to-confirm names: browsers and password managers must not fill them. -->
  <FormTextInput
    ref="inputRef"
    :name="name"
    :placeholder="placeholder"
    :input-attrs="{
      autocomplete: 'off',
      'data-1p-ignore': 'true',
      'data-lpignore': 'true',
      'data-bwignore': 'true',
      'data-form-type': 'other',
    }"
  />
</template>
